export default __webpack_public_path__ + "static/media/svtv-linkedin-logo.ed6027b6.svg";